import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { CommitmentKpi, GoalStatus } from '../../coaching-base/general';
import { TranslationKeyMap } from '../coaching-commitment.i18n';

// TODO consolidate
export const goalStatusTranslationMap = {
    [GoalStatus.DRAFT]: TranslationKeyMap._9476_DRAFT,
    [GoalStatus.PRE_APPROVAL]: TranslationKeyMap._9495_PRE_APPROVAL,
    [GoalStatus.ACTIVE]: TranslationKeyMap._125_ACTIVE,
    [GoalStatus.PENDING_CLOSE]: TranslationKeyMap._7441_PENDING_CLOSE,
    [GoalStatus.CLOSED]: TranslationKeyMap._7440_CLOSED,
    [GoalStatus.DELETED]: TranslationKeyMap._9496_DELETED,
    [GoalStatus.UPDATING]: TranslationKeyMap._8702_UPDATING,
};

@Component({
    selector: 'cmps-shared-goals-commitment',
    templateUrl: './shared.goals.commitment.component.html',
    host: {
        class: 'cmps-shared-goals-commitment',
    },
})
export class SharedGoalsCommitmentComponent {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _GoalStatus = GoalStatus;
    /** @private */ _goalStatusTranslationMap = goalStatusTranslationMap;

    constructor(
        private readonly _router: Router,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            SharedGoalsCommitmentComponent,
            void
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: {
            selectedGoalId: any;
            goalsActives: CommitmentKpi[];
        },
    ) {}
}
